<template>
  <div>
    <default-modal
      v-model="modalOpened"
      name="add-item-modal"
      :autofocus="$refs.itemsForm"
      :successHandler="handleSave"
      :title="$t('add_item')"
      width="sm"
    >
      <items-form slot="content" ref="itemsForm"></items-form>
    </default-modal>

    <q-page-sticky position="bottom-right" :offset="[18, 18]">
      <q-btn @click="modalOpened = true" color="primary" class="add-item__button" round fab>
        <q-icon name="add"></q-icon>
      </q-btn>
    </q-page-sticky>
  </div>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import ItemsForm from './ItemsForm.vue'

  export default {
    data () {
      return {
        modalOpened: false
      }
    },

    methods: {
      handleSave () {
        this.$refs.itemsForm.create()
          .then(success => {
            if (!success) {
              return
            }

            this.modalOpened = false
            this.$refs.itemsForm.reset()
          })
      },

      open () {
        this.modalOpened = true
      }
    },

    components: {
      ItemsForm,
      DefaultModal
    }
  }
</script>
